import React, { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../../AnimatedLetters'
import './index.scss'

const DreamsIT = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="col s12 center-align">
          <h1 className={letterClass}>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['D', 'r', 'e', 'a', 'm', 's', ' ', 'I', 'T']}
              idx={15}
            />
          </h1>
        </div>

        <h3 className="experience-title">Dreams - Service Desk Analyst</h3>

        {/* Project Containers */}
        <div className="row project-container-wrapper">
          <div className="col s12 m6 project-container-1">
            <h4>• First and Second Line Support</h4>
            <p>
              - Issue Diagnosis and Resolution: Delivered fast and accurate
              troubleshooting across a wide range of hardware and software
              issues, including network connectivity, system errors, and
              application support. Consistently maintained high first-time fix
              rates, minimising downtime for end users.
            </p>
            <p>
              - User Account and Access Management: Managed Active Directory
              accounts, reset passwords, assigned security permissions, and
              provided access control using Azure EntraID, ensuring users had
              appropriate access based on their roles while adhering to security
              policies.
            </p>
            <p>
              - Security Compliance and Data Protection: Strictly adhered to
              company policies regarding GDPR and PCI compliance, ensuring the
              safe handling of personal and payment data. Applied security best
              practices when accessing, processing, or storing sensitive
              information.
            </p>
            <p>
              - Proactive Issue Monitoring: Regularly conducted system health
              checks and monitoring to identify potential problems before they
              escalated. Escalated issues to relevant teams as needed, ensuring
              seamless IT operations with minimal disruption.
            </p>
          </div>

          <div className="col s12 m6 project-container-2">
            <h4>• Structuring and Management of Active Directory OUs</h4>
            <p>
              - Automated manual deployment of start menu adverts by creating
              two sub-OUs within the original AD structure, each containing
              specific machines.
            </p>
            <p>
              - Ensured accurate targeting by segregating machines into relevant
              sub-OUs, allowing for efficient and precise software deployments.
            </p>
            <p>
              - Improved system administration efficiency by creating a more
              organised and structured OU system, reducing time spent on manual
              targeting for future deployments.
            </p>
          </div>

          <div className="col s12 m6 project-container-3">
            <h4>• Leading IT projects for New Store Openings</h4>
            <p>
              - Optimised IT Store Setup: I set up a mock IT store in the office
              server room, where I built, configured, and tested all hardware to
              ensure a seamless plug-and-play installation process.
            </p>
            <p>
              - Network Cabinet Installation and Patching: Leveraged a Cisco
              24-port switch, Meraki MX68, and Meraki MR46 AP to create a fully
              functional network environment, enabling secure and efficient
              communication across devices.
            </p>
            <p>
              - Device Imaging and Configuration: Imaged Dell Optiplex PCs and
              configured Yealink phones, Worldpay Card Machines, and Xerox
              printers using intuitive GUI interfaces for optimal deployment
              speed.
            </p>
            <p>
              - Network Configuration: Assigned static or DHCP IP addresses to
              all machines, ensuring seamless communication and full network
              visibility, where all devices were pingable and properly
              integrated into the network.
            </p>
            <p>
              - End-to-End IT Testing: Conducted end-to-end testing of the
              store's IT infrastructure, from network connectivity to device
              functionality, ensuring that all systems met operational standards
              before the store opened.
            </p>
            <p>
              - I created a project board using Microsoft Planner to streamline
              the new store opening process. Each task was organized into
              distinct sections: 'To Do', 'In Progress', 'In Test', and 'Build
              Complete'. I assigned tasks to relevant team members, ensuring
              clear accountability and real-time tracking of project milestones.
              This approach improved collaboration and ensured a smooth,
              organised workflow.
            </p>
          </div>

          <div className="col s12 m6 project-container-4">
            <h4>
              • Documentation, Knowledge Sharing, Leadership, and Mentoring
            </h4>
            <p>
              - Creation and Maintenance of Documentation: Developed and
              maintained comprehensive documentation for troubleshooting
              processes and critical IT functions, including Standard Operating
              Procedures (SOPs). This improved team efficiency, ensured
              compliance with GDPR, and provided consistent, reliable solutions
              to recurring technical issues.
            </p>
            <p>
              - Team Leadership During Critical Incidents: Stepped into
              leadership roles during management absences, coordinating the team
              in resolving high-priority issues and ensuring calm, structured
              responses to incidents. Promoted collaboration and peer reviews of
              technical solutions to increase accuracy and performance.
            </p>
            <p>
              - Ongoing Documentation Updates and Empowerment: Regularly updated
              documentation to reflect software and system changes, ensuring the
              team stayed current. Empowered team members by delegating tasks
              based on individual strengths, providing support when needed, and
              encouraging independent decision-making on technical matters.
            </p>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default DreamsIT
